/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Board_Hub_HintInputs */

const en_us2_board_hub_hint = /** @type {(inputs: Board_Hub_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tips and ideas from people who train, with votes`)
};

const pt_br2_board_hub_hint = /** @type {(inputs: Board_Hub_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dicas e ideias de quem treina, com votação`)
};

const pt_pt2_board_hub_hint = /** @type {(inputs: Board_Hub_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dicas e ideias de quem treina, com votação`)
};

/** @type {(inputs: Board_Hub_HintInputs) => LocalizedString} */
const es_419_board_hub_hint = en_us2_board_hub_hint;

/** @type {(inputs: Board_Hub_HintInputs) => LocalizedString} */
const fr_fr2_board_hub_hint = en_us2_board_hub_hint;

/** @type {(inputs: Board_Hub_HintInputs) => LocalizedString} */
const de_de2_board_hub_hint = en_us2_board_hub_hint;

/** @type {(inputs: Board_Hub_HintInputs) => LocalizedString} */
const it_it2_board_hub_hint = en_us2_board_hub_hint;

/**
* | output |
* | --- |
* | "Tips and ideas from people who train, with votes" |
*
* @param {Board_Hub_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const board_hub_hint = /** @type {((inputs?: Board_Hub_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Board_Hub_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_board_hub_hint(inputs)
	if (locale === "es-419") return es_419_board_hub_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_board_hub_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_board_hub_hint(inputs)
	if (locale === "de-DE") return de_de2_board_hub_hint(inputs)
	if (locale === "it-IT") return it_it2_board_hub_hint(inputs)
	return en_us2_board_hub_hint(inputs)
});
export { board_hub_hint as "board.hub_hint" }